// extracted by mini-css-extract-plugin
export default {"buttons":"PrivacyModal_buttons__f22tq","primaryButton":"PrivacyModal_primaryButton__QfurD"};